
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    GetOpenId({
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            api.get('Shared/GetOpenId', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    GetJssdkConfig({
        commit
    }, payload) {

        return new Promise((resolve, reject) => {
            api.get('Shared/GetJssdkConfig', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    // 获取城市地区列表
    GetSharedGetAreasList({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.get('/Shared/GetAreasList', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    GetAreasListVue({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.get('/Shared/GetAreasListVue', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    GetRechargePricleList({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.get('/Shared/GetRechargePricleList', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    GetWeiXinPaymentParames({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.get("Shared/GetWeiXinPaymentParames", payload,
                res => {
                    resolve(res)
                }, err => {
                    reject(err)
                })
        })

    },
    GetRandomNum({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.get("Shared/GetRandomNum", payload,
                res => {
                    resolve(res)
                }, err => {
                    reject(err)
                })
        })
    },
    GetSendSms({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.post("Shared/SendSmsVue", payload,
                res => {
                    resolve(res.Result)
                }, err => {
                    reject(err)
                })
        })
    },
    ResetPassword({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.post("Shared/ResetPasswordVue", payload,
                res => {
                    resolve(res.Result)
                }, err => {
                    reject(err)
                })
        })
    },
    


}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
